import React from 'react';

import { EsteiraParalelaDoCarro } from '../../../interfaces/Car';
import './faixa-de-paralelas.css';

interface FaixaDeParalelasProps {
  /** A etapa do veículo, como o colaborador a lê na tela. */
  esteiraPrincipalNome?: string | null;
  /** As paralelas vigentes. Vazio ⇒ nada é renderizado. */
  esteirasParalelas?: EsteiraParalelaDoCarro[] | null;
}

/**
 * Faixa "este veículo tem serviço em paralelo" (at-99, ADR 0050) — aba "Meus Veículos".
 *
 * Existe para responder, antes de o colaborador clicar, a pergunta que o card não responde: o
 * veículo está numa etapa e há outro serviço em curso nele ao mesmo tempo, então **a esteira em
 * que ele vai apontar a hora é uma escolha**, e não o que estiver escrito no card.
 *
 * Sem isso, o mecânico abriria o modal, veria um seletor que não esperava e concluiria que o
 * sistema mudou de comportamento sem motivo.
 *
 * ⚠️ O silêncio em falha é deliberado aqui, e a diferença em relação ao bloco do Chefe é o que
 * a faixa AFIRMA: ela não diz "não há serviço em paralelo", ela só acrescenta informação quando
 * há. Os dados vêm do próprio veículo já carregado (`esteirasParalelas` nas listagens), sem
 * requisição própria — não existe estado de erro a distinguir.
 */
const FaixaDeParalelas: React.FC<FaixaDeParalelasProps> = ({
  esteiraPrincipalNome,
  esteirasParalelas,
}) => {
  if (!esteirasParalelas || esteirasParalelas.length === 0) return null;

  const nomes = esteirasParalelas.map((p) => p.nome).filter(Boolean);
  if (nomes.length === 0) return null;

  return (
    <div className="faixa-de-paralelas">
      <strong>Serviço em paralelo neste veículo.</strong> Ele está em{' '}
      <strong>{esteiraPrincipalNome ?? 'sua etapa atual'}</strong> e também tem serviço em curso em{' '}
      <strong>{nomes.join(', ')}</strong>. Ao iniciar, escolha a esteira do serviço que você vai
      fazer — suas horas são apontadas nela.
    </div>
  );
};

export default FaixaDeParalelas;
